export const appendFiltersToFormData = (filters, filtersName, form_data) => {
    filters.forEach((item) => {
        const filterName = item.id.split("_")[0];
        if (item.type === "list" && item.id === "postCategorySpecialty") {
            const values = item.value.map((item) => item.id).join(",");
            form_data.append(`${filtersName}[posts][search_type]`, item.searchType);
            form_data.append(`${filtersName}[posts][values]`, values);
        } else if (item.type === "list") {
            if (item.id === "workerType") {
                form_data.append(`${filtersName}[${filterName}][value]`, item.value[0].id);
            } else {
                let values = item.value.map((item) => item.id);
                values = values.filter((v, i) => values.indexOf(v) === i).join(",");
                form_data.append(`${filtersName}[${filterName}][search_type]`, item.searchType);
                form_data.append(`${filtersName}[${filterName}][values]`, values);
            }
        } else if (item.type === "number" && item.searchType === "4") {
            form_data.append(`${filtersName}[${filterName}][value]`, item.value.start);
            form_data.append(`${filtersName}[${filterName}][search_type]`, item.searchType);
            form_data.append(`${filtersName}[${filterName}][value_2]`, item.value.end);
        } else if (item.type === "boolean") {
            if (item.value === "1") form_data.append(`${filtersName}[${filterName}][value]`, item.value);
        } else {
            form_data.append(`${filtersName}[${filterName}][value]`, item.value);
            form_data.append(`${filtersName}[${filterName}][search_type]`, item.searchType);
        }
    });
};
